import React, { useState, useEffect, useRef } from "react";
import "./style.css";

function ProfMultiStepForm() {
    const [currentTab, setCurrentTab] = useState(0);
    const [finishedTabs, setFinishedTabs] = useState(new Set());
    const tabsRef = useRef([]);
    const stepsRef = useRef([]);

    useEffect(() => {
        showTab(currentTab);
    }, [currentTab]);

    const showTab = (n) => {
        if (tabsRef.current.length === 0 || stepsRef.current.length === 0) return;
        tabsRef.current.forEach((tab, index) => {
            tab.style.display = index === n ? "block" : "none";
        });
        document.getElementById("prevBtn").style.display = n === 0 ? "none" : "inline";
        document.getElementById("nextBtn").innerHTML = n === tabsRef.current.length - 1 ? "Submit" : "Next";

        updateStepIndicators(n);
    };

    const nextPrev = (n) => {
        const newIndex = currentTab + n;
        if (newIndex >= 0 && newIndex < tabsRef.current.length) {
            if (n === 1) {
                setFinishedTabs((prev) => new Set(prev).add(currentTab));
            }
            setCurrentTab(newIndex);
        }
    };

    const updateStepIndicators = (n) => {
        if (stepsRef.current.length === 0) return;

        stepsRef.current.forEach((step) => {
            step.classList.remove("active");
            step.classList.remove("finish");
        });

        if (stepsRef.current[n]) {
            stepsRef.current[n].classList.add("active");
        }

        stepsRef.current.forEach((step, index) => {
            if (index < n) {
                step.classList.add("finish");
            }
        });
    };


    // IMAGES UPLOAD AND DELETE

    const [images, setImages] = useState([]);

    const handleImageUpload = (event) => {
        const files = Array.from(event.target.files);
        setImages((prevImages) => [...prevImages, ...files]);
    };

    const handleImageRemove = (index) => {
        setImages((prevImages) => prevImages.filter((_, i) => i !== index));
    };

    // IMAGES UPLOAD AND DELETE FOR TAB FOUR

    const [imagesTabFour, setImagesTabFour] = useState([]);

    const handleImageUploadForTabFour = (event) => {
        const filesTabFour = Array.from(event.target.files);
        setImagesTabFour((prevImages) => [...prevImages, ...filesTabFour]);
    };

    const handleImageRemoveTabFour = (index) => {
        setImagesTabFour((prevImages) => prevImages.filter((_, i) => i !== index));
    };

    return (
        <div className="add-employee-box pb-5">
            <form id="regForm" onSubmit={(e) => e.preventDefault()}>

                <div className="steps-circle-box">
                    <span
                        className="step"
                        ref={(el) => (stepsRef.current[0] = el)}
                    ></span>
                    <span
                        className="step"
                        ref={(el) => (stepsRef.current[1] = el)}
                    ></span>
                    <span
                        className="step"
                        ref={(el) => (stepsRef.current[2] = el)}
                    ></span>
                    <span
                        className="step"
                        ref={(el) => (stepsRef.current[3] = el)}
                    ></span>
                </div>

                <div className="tab" ref={(el) => (tabsRef.current[0] = el)}>
                    <div className="container">
                        <div className="row">
                            <div className="col-md-6">
                                <div className="employee-form-box">
                                    <h1 className="mb-4">Edit Profile</h1>
                                    <h2>Basic Information:</h2>
                                </div>

                                <div className="mb-3 custom-input-box">
                                    <input type="text" className="form-control" placeholder="Full Name" />
                                </div>

                                <div className="form-box-inputs custom-input-box">
                                    <input type="text" defaultValue={+1} className="phone-code" />
                                    <input type="number" placeholder="Phone Number" className="phone-number" />
                                </div>

                                <div className="mb-3 custom-input-box">
                                    <input type="email" className="form-control" placeholder="Email Address" />
                                </div>

                                <div className="mb-3 custom-input-box">
                                    <input type="text" className="form-control" placeholder="About Yourself" />
                                </div>

                                <div className="logo-box">
                                    <h3 className="second-text-heading">Covid Insurance</h3>
                                    <label htmlFor="upload-image" className="upload-image"><span className='bg-white'>Upload Image</span></label>
                                    <input
                                        type="file"
                                        className="d-none"
                                        id="upload-image"
                                        accept="image/*"
                                    />
                                </div>
                            </div>

                            <div className="col-md-2"></div>

                            <div className="col-md-4">
                                <div className="profile-image profile-box-black">
                                    <img src="/images/user.png" alt="" />
                                    <div className="profile-buttons">
                                        <span className='btns'><i className="fa-solid fa-pen-to-square"></i></span>
                                        <span className='btns'><i className="fa-solid fa-trash"></i></span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="tab" ref={(el) => (tabsRef.current[1] = el)}>
                    <div className="container">
                        <div className="row">
                            <div className="col-md-6">
                                <div className="employee-form-box">
                                    <h1 className="mb-4">Edit Profile</h1>
                                    <h2>Professional Details</h2>
                                </div>

                                <div className="mb-3 custom-input-box">
                                    <input type="text" className="form-control" placeholder="Professional Title" />
                                </div>

                                <div className="mb-3 custom-input-box">
                                    <input type="text" className="form-control" placeholder="I offer Services" />
                                </div>

                                <div className="mb-3 custom-input-box">
                                    <input type="text" className="form-control" placeholder="I also provide additional Services (tags)" />
                                </div>

                                <div className="form-box-inputs custom-input-box">
                                    <select className="form-select" aria-label="Default select example">
                                        <option selected>Price for the services</option>
                                        <option value="1">One</option>
                                        <option value="2">Two</option>
                                        <option value="3">Three</option>
                                    </select>

                                    <select className="form-select currency-code" aria-label="Default select example">
                                        <option selected>USD</option>
                                        <option value="1">One</option>
                                        <option value="2">Two</option>
                                        <option value="3">Three</option>
                                    </select>
                                </div>

                                <div className="form-box-inputs custom-input-box">
                                    <select className="form-select" aria-label="Default select example">
                                        <option selected>Price applicable for (per hour)</option>
                                        <option value="1">One</option>
                                        <option value="2">Two</option>
                                        <option value="3">Three</option>
                                    </select>
                                </div>

                                <div className="form-box-inputs custom-input-box">
                                    <select className="form-select" aria-label="Default select example">
                                        <option selected>Is price nigotiable</option>
                                        <option value="1">One</option>
                                        <option value="2">Two</option>
                                        <option value="3">Three</option>
                                    </select>
                                </div>


                            </div>

                            <div className="col-md-6">
                                <div className="employee-form-box tab-space-box-top">
                                    <h2>My Media</h2>
                                </div>

                                <div className="logo-box">
                                    <h3 className="second-text-heading">Logo</h3>
                                    <label htmlFor="upload-image-logo" className="upload-image"><span className='bg-white'>Upload Image</span></label>
                                    <input
                                        type="file"
                                        className="d-none"
                                        id="upload-image-logo"
                                        accept="image/*"
                                        multiple
                                        onChange={handleImageUpload}
                                    />
                                </div>

                                <div className="media-box">
                                    <h3 className="second-text-heading">Media</h3>

                                    <div className="my-media-images">
                                        {images.map((image, index) => (
                                            <div key={index} className="image-media-box">
                                                <img src={URL.createObjectURL(image)} alt={`Uploaded Preview ${index}`} />
                                                <span onClick={() => handleImageRemove(index)}>Delete</span>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="tab" ref={(el) => (tabsRef.current[2] = el)}>
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12">
                                <div className="employee-form-box">
                                    <h1 className="mb-3">Work days & Time</h1>
                                </div>
                                <h3 className="second-text-heading">Select Week Days</h3>
                                <div className="checkbox-group-blocks-label-wrap">
                                    <ul>
                                        <li>
                                            <label>
                                                <input type="checkbox" />
                                                <span className="label-text">Mon</span>
                                            </label>
                                        </li>
                                        <li>
                                            <label>
                                                <input type="checkbox" />
                                                <span className="label-text">Tue</span>
                                            </label>
                                        </li>
                                        <li>
                                            <label>
                                                <input type="checkbox" />
                                                <span className="label-text">Wed</span>
                                            </label>
                                        </li>
                                        <li>
                                            <label>
                                                <input type="checkbox" />
                                                <span className="label-text">Thu</span>
                                            </label>
                                        </li>
                                        <li>
                                            <label>
                                                <input type="checkbox" />
                                                <span className="label-text">Fri</span>
                                            </label>
                                        </li>
                                        <li>
                                            <label>
                                                <input type="checkbox" />
                                                <span className="label-text">Sat</span>
                                            </label>
                                        </li>
                                        <li>
                                            <label>
                                                <input type="checkbox" />
                                                <span className="label-text">Sun</span>
                                            </label>
                                        </li>
                                    </ul>
                                </div>

                                <h3 className="second-text-heading mt-4">Timings</h3>
                                <div className='reg-checkbox-custom-box'>
                                    <label className="timings checkbox">
                                        <input type="radio" name="timing-input" />
                                        <span className="checkmark" />
                                        Same for all days
                                    </label>

                                    <label className="timings checkbox">
                                        <input type="radio" name="timing-input" />
                                        <span className="checkmark" />
                                        Different for all days
                                    </label>
                                </div>

                                <div className="time-slots">
                                    <div className="time-slot-day">
                                        <h3 className="second-text-heading mt-4">Monday</h3>
                                        <h2><span>10:00 AM</span> to <span>01:00 PM</span> <i className="fa-solid fa-plus"></i></h2>
                                    </div>

                                    <div className="time-slot-day">
                                        <h3 className="second-text-heading mt-4">Tuesday</h3>
                                        <h2><span>10:00 AM</span> to <span>01:00 PM</span> <i className="fa-solid fa-plus"></i></h2>
                                    </div>

                                    <div className="time-slot-day">
                                        <h3 className="second-text-heading mt-4">Wednesday</h3>
                                        <h2><span>10:00 AM</span> to <span>01:00 PM</span> <i className="fa-solid fa-plus"></i></h2>
                                    </div>

                                    <div className="time-slot-day">
                                        <h3 className="second-text-heading mt-4">Thursday</h3>
                                        <h2><span>10:00 AM</span> to <span>01:00 PM</span> <i className="fa-solid fa-plus"></i></h2>
                                    </div>

                                    <div className="time-slot-day">
                                        <h3 className="second-text-heading mt-4">Friday</h3>
                                        <h2><span>10:00 AM</span> to <span>01:00 PM</span> <i className="fa-solid fa-plus"></i></h2>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="tab" ref={(el) => (tabsRef.current[3] = el)}>
                    <div className="container">
                        <div className="row">
                            <div className="col-xl-6 col-lg-6 col-md-12">
                                <div className="employee-form-box">
                                    <h1 className="mb-4">Edit Profile</h1>
                                    <h2>Past Work Details</h2>
                                </div>

                                <div className="mb-3 custom-input-box">
                                    <input type="text" className="form-control" placeholder="Work Title" />
                                </div>

                                <div className="mb-3 custom-input-box">
                                    <input type="text" className="form-control" placeholder="Location" />
                                </div>

                                <div className="mb-3 custom-input-box">
                                    <input type="text" className="form-control" placeholder="Discription" />
                                </div>

                                <h3 className="second-text-heading">Photos for past work</h3>

                                <div className="logo-box">
                                    <label htmlFor="upload-image-logo-tab-4" className="upload-image"><span className='bg-white'>Upload Image</span></label>
                                    <input
                                        type="file"
                                        className="d-none"
                                        id="upload-image-logo-tab-4"
                                        accept="image/*"
                                        multiple
                                        onChange={handleImageUploadForTabFour}
                                    />
                                </div>

                                <div className="my-media-images mt-4">
                                    {imagesTabFour.map((image, index) => (
                                        <div key={index} className="image-media-box">
                                            <img src={URL.createObjectURL(image)} alt={`Uploaded Preview ${index}`} />
                                            <span onClick={() => handleImageRemoveTabFour(index)}>Delete</span>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div style={{ overflow: "auto" }}>
                    <div className="submit-btn-form">
                        <button type="button" className="btn btn-primary me-2" id="prevBtn" onClick={() => nextPrev(-1)}>
                            Previous
                        </button>

                        <button type="button" className="btn btn-primary" id="nextBtn" onClick={() => nextPrev(1)}>
                            Next
                        </button>
                    </div>
                </div>
            </form>
        </div>
    );
}

export default ProfMultiStepForm;